<template>
    <v-layout column>
        <v-spacer class="my-2"></v-spacer>

        <!-- @modified ana.castro 2019.11.25 SCLAPP-23: the name must be centered-->
        <!-- <v-layout v-if="customer && customer.name" row align-center justify-center align-content-center>-->

        <v-layout v-if="customer && customer.name" row align-center justify-center align-content-center
                  style="text-align: center">
            <h1 class="home-username text-uppercase">
                <span class="username-pre primary--text">'</span>
                <span>{{ $vuetify.t('$vuetify.user_welcome') }}, </span><span>{{ customer.name }}</span>
                <span class="username-pos primary--text">'</span>
            </h1>
        </v-layout>
        <!--<v-layout v-else row align-center justify-center align-content-center>
            <h1 class="text-uppercase">Olá</h1>
        </v-layout>-->

        <v-spacer class="my-2 home-spacer1"></v-spacer>

        <v-layout v-if="customer && customer.loyalty.nr_points >= 0" row align-center justify-center
                  align-content-center>
            <div id="points">
                <h2 class="text-xs-center primary--text">{{ customer.loyalty.nr_points }}</h2>
                <h3 class="text-xs-center text-lowercase blue-grey--text text--lighten-4">{{
                        $vuetify.t('$vuetify.points')
                    }}</h3>
            </div>
        </v-layout>

        <v-spacer class="my-3 home-spacer2"></v-spacer>

        <v-flex v-if="shopAvailable && customer && customer.active_orders"
                style="text-align: center">
            <v-alert
                    :value="true"
                    color="success"
                    icon="fal fa-envelope-open"
                    outline
                    @click="goToMyOrders"
                    class="v-list__tile--link white title"
            >
                <v-badge color="green">
                    <template v-slot:badge>
                        <span>{{ customer.active_orders }}</span>
                    </template>
                    {{ $vuetify.t('$vuetify.shop.remember_orders_in_progress') }}
                </v-badge>
            </v-alert>
        </v-flex>
        <v-flex v-if="shopAvailable && cartNumberItems > 0"
                style="text-align: center">
            <v-alert
                    :value="true"
                    color="info"
                    icon="fal fa-shopping-cart"
                    outline
                    @click="goShoppingCart"
                    class="v-list__tile--link white title"
            >
                <v-badge color="blue">
                    <template v-slot:badge>
                        <span>{{ cartNumberItems }}</span>
                    </template>
                    {{ $vuetify.t('$vuetify.shop.remember_shop_cart') }}
                </v-badge>
            </v-alert>
        </v-flex>

        <v-spacer v-if="shopAvailable && (cartNumberItems > 0 || (customer && customer.active_orders))"
                  class="my-2 home-spacer1"></v-spacer>

        <v-layout row v-if="highlights.length">
            <v-flex>
                <v-carousel>
                    <v-carousel-item v-for="highlight in highlightsWithImage" :key="highlight.id">
                        <!-- @modified ana.castro 2019.11.25 SCLAPP-23: the highlights must include a link-->
                        <v-card color="transparent" :href="highlight.website" target="_blank">
                            <v-img v-if="baseUrl" :src="baseUrl + highlight.image" height="500" contain></v-img>
                        </v-card>
                    </v-carousel-item>
                </v-carousel>
            </v-flex>
        </v-layout>

        <!-- CASO MAIS TARDE SE QUEIRA O SLIDER -->
        <!--<v-layout-->
        <!--row-->
        <!--wrap-->
        <!--&gt;-->
        <!--<v-flex xs12>-->
        <!--<v-slider-->
        <!--v-model="slider"-->
        <!--thumb-label="always"-->
        <!--readonly-->
        <!--inverse-label-->
        <!--:max=maxSlider-->
        <!--:label=maxSlider-->
        <!--&gt;</v-slider>-->
        <!--</v-flex>-->

        <!--<v-flex xs12 align-content-center>-->
        <!--<div class="text-xs-center pa-5">-->
        <!--<h3 style="color: #9363cd">Próxima Campanha: faltam {{pointsToAchieveCampaign}}</h3>-->
        <!--</div>-->
        <!--</v-flex>-->
        <!--</v-layout>-->

        <!-- modified @daniel.silva 2020.07.05 SCLAPP-29 -->
        <EInvoice :enabled=einvoiceAlert
                  @changeEinvoiceAlert="changeEinvoiceAlert"></EInvoice>
        <UpdatedTC :enabled=updatedTCAlert></UpdatedTC>

    </v-layout>
</template>

<script>
import {mapGetters} from 'vuex';
import {highlightsService, userService} from '../../_services';
import {getErrorMessage} from '../../_helpers';
import EInvoice from "../../components/EInvoice";
import UpdatedTC from "../../components/UpdatedTC";

export default {
    name: "Home",
    components: {EInvoice, UpdatedTC},
    data() {
        return {
            slider: 0,
            maxSlider: 0,
            pointsToAchieveCampaign: 0,
            highlights: [],
            customer: null,
            einvoiceAlert: false,
            updatedTCAlert: false,
            shopAvailable: false
        }
    },
    methods: {
        changeEinvoiceAlert: function (einvoiceAlert) {
            this.einvoiceAlert = einvoiceAlert;
        },
        goShoppingCart: function () {
            this.$router.push({name: 'order-cart'})
        },
        goToMyOrders: function () {
            this.$router.push({name: 'orders'})
        },
    },
    computed: {
        user() {
            return this.$store.state.authentication.user;
        },
        highlightsWithImage: function () {
            return this.highlights.filter(highlight => highlight.image)
        },
        ...mapGetters({
            cartNumberItems: 'shop/cartSize',
            baseUrl: 'configs/apiImgBaseUrl',
        }),
    },
    mounted() {
        this.$store.dispatch("loader/setLoading", true);
        this.shopAvailable = this.$store.state.shopAvailable;

        highlightsService.getAll().then(result => {
                this.highlights = result.results;
            },
            // eslint-disable-next-line
            error => {
                this.$store.dispatch("loader/setLoading", false);
                this.$store.dispatch("alert/error", this.$vuetify.t('$vuetify.generic_error'));
            });

        // eslint-disable-next-line
        userService.get().then(result => {
                this.customer = result;
                this.einvoiceAlert = this.customer.show_einvoice_alert === 1;
                this.updatedTCAlert = this.customer.gdpr_agreement_review_date === 1;
                this.slider = this.customer.loyalty.nr_points;
                this.maxSlider = this.customer.loyalty.nr_points_next_available_campaign;
                this.pointsToAchieveCampaign = this.customer.loyalty.nr_points_next_available_campaign - this.customer.loyalty.nr_points;
                this.$store.dispatch("loader/setLoading", false);
            },
            error => {
                getErrorMessage(error, 'Getting Customer Data', this);
            });
    },
}
</script>

<style scoped>

</style>
